// extracted by mini-css-extract-plugin
export default {"mainArea":"FirstExamination_mainArea__D8Pta","block":"FirstExamination_block__FZ+d6","title":"FirstExamination_title__K93oz"};